import React from 'react';
import '../styles/BottomNavigation.css';
import { Platform } from '../utils/platform';

// Static SVG icons - no React re-renders, pure HTML
const HomeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

const GridIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="7" height="7" x="3" y="3" rx="1"/>
    <rect width="7" height="7" x="14" y="3" rx="1"/>
    <rect width="7" height="7" x="14" y="14" rx="1"/>
    <rect width="7" height="7" x="3" y="14" rx="1"/>
  </svg>
);

const CartIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8" cy="21" r="1"/>
    <circle cx="19" cy="21" r="1"/>
    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
  </svg>
);

const UserIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

const BottomNavigation = ({ currentPage, onNavigate, cartItemsCount = 0, hidden = false }) => {
  const handleNavigation = (page) => {
    // Haptic feedback для Telegram
    if (window.Telegram?.WebApp?.HapticFeedback) {
      window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
    }
    onNavigate(page);
  };

  // Скрываем навигацию когда открыта модалка
  if (hidden) return null;

  return (
    <nav className="bottom-navigation">
      <button
        className={`nav-item ${currentPage === 'home' ? 'active' : ''}`}
        onClick={() => handleNavigation('home')}
        aria-label="Главная"
        aria-current={currentPage === 'home' ? 'page' : undefined}
      >
        <HomeIcon />
        <span className="nav-label">Главная</span>
      </button>

      <button
        className={`nav-item ${currentPage === 'catalog' ? 'active' : ''}`}
        onClick={() => handleNavigation('catalog')}
        aria-label="Каталог"
        aria-current={currentPage === 'catalog' ? 'page' : undefined}
      >
        <GridIcon />
        <span className="nav-label">Каталог</span>
      </button>

      <button
        className={`nav-item ${currentPage === 'cart' ? 'active' : ''}`}
        onClick={() => handleNavigation('cart')}
        aria-label="Корзина"
        aria-current={currentPage === 'cart' ? 'page' : undefined}
      >
        <div className="nav-icon-wrapper">
          <CartIcon />
          {cartItemsCount > 0 && (
            <span className="cart-badge">{cartItemsCount}</span>
          )}
        </div>
        <span className="nav-label">Корзина</span>
      </button>

      <button
        className={`nav-item ${currentPage === 'profile' ? 'active' : ''}`}
        onClick={() => handleNavigation('profile')}
        aria-label="Профиль"
        aria-current={currentPage === 'profile' ? 'page' : undefined}
      >
        <UserIcon />
        <span className="nav-label">Профиль</span>
      </button>
    </nav>
  );
};

export default React.memo(BottomNavigation);
